qtee.customDesign = window.qtee.customDesign || {};

qtee.customDesign.FontTextView = Backbone.Marionette.ItemView.extend({
	template: '/custom-design/templates/text-font',
	ui: {
		back: '.back',
		fontSlider: '.scrollable',
		fonts: '.font'
	},
	events: {
		'click @ui.fonts': 'fontClick',
		'click @ui.back': 'backClick'
	},
	backClick: function () {

		this.$events.triggerHandler('back.FontTextView');
		this.backCallback && this.backCallback({ fontChangedTo: this.state.fontChangedTo });


	},
	fontClick: function (e) {

		var that = this,
			$f = $(e.target),
			fontFamily = qtee.customDesign.fonts.getInfo($f.data('fontI')).name,
			weight = $f.data('fontWeight'),
			style = $f.data('fontStyle'),
			element = qtee.customDesign.canvas.getElement({ cid: this.model.cid });

		this.state.waitFont = true;

		if (element) {

			var stopTimer = this.$events.triggerHandler('startLoader');
			this.$events.triggerHandler('showProgressState');

			element.setFont(fontFamily, weight, style).then(function () {

				stopTimer();
				that.$events.triggerHandler('showSuccessState', 'font "' + fontFamily + '" was downloaded');
				that.state.waitFont = false;
				that.state.fontChangedTo = {
					fontFamily: fontFamily,
					weight: weight,
					style: style
				};

				that.ui.fonts.removeClass('selected');
				$f.addClass('selected');

				if (!that.model.isNew()) {

					that.model.save(element.saveToModel(), {
						success: function (r) {

							that.$events.triggerHandler('add.history', [ [ r ] ]);

						}
					});

				}

			}, stopTimer);

			// set font family of newEl created next to match fontBold
			qtee.customDesign.settings.newEl.text.fontBold = weight;

			switch (weight) {
				case 900:
					fontFamily = fontFamily + ' black';
					break;
				case 800:
					fontFamily = fontFamily + ' extraBold';
					break;
				case 700:
					fontFamily = fontFamily + ' bold';
					break;
				case 600:
					fontFamily = fontFamily + ' semiBold';
					break;
				case 500:
					fontFamily = fontFamily + ' medium';
					break;
				case 300:
					fontFamily = fontFamily + ' light';
					break;
				case 275:
					fontFamily = fontFamily + ' extraLight';
					break;
				case 250:
					fontFamily = fontFamily + ' thin';
					break;
				default:
					fontFamily = fontFamily;
			}

			// set font family of newEl created next to match fontFamily
			qtee.customDesign.settings.newEl.text.fontFamily = fontFamily;

			// set font family of newEl created next to match fontItalic
			if (style === 'italic') {

				qtee.customDesign.settings.newEl.text.fontItalic = true;

			} else {

				qtee.customDesign.settings.newEl.text.fontItalic = false;

			}

		} else {

			that.state.waitFont = false;
			that.ui.fonts.removeClass('selected');
			$f.addClass('selected');

			that.model.set({
				FontName: fontFamily
			});

		}

	},
	initialize: function (opts) {

		opts.backCallback && (this.backCallback = opts.backCallback);
		this.state = {};
		this.$events = $(qtee.customDesign);

	},
	templateHelpers: function () {

		var fonts = qtee.customDesign.fonts.getFontsPreviewsList(),
			font = qtee.customDesign.fonts.parseFontName(this.model.get('FontName')),
			style = this.model.get('IsItalic') ? 'italic' : 'normal',
			selected = _.findWhere(fonts, { fontFamily: font.family, weight: font.weight, style: style });

		selected && (selected.selected = true);

		_.forEach(fonts, function (el) {

			el.css = el.fontFamily.replace(/ /g, '').toLowerCase() + el.subFamily;

		});

		return {
			fonts: fonts
		};

	},
	onAttach: function () {

		var that = this,
			i = this.ui.fontSlider.find('.font.selected').parents('.item').index();

		// init scrollables and navigator
		$(this.ui.fontSlider).scrollable({ touch: true }).navigator();

		// scroll to selected font
		setTimeout(function () {

			$(that.ui.fontSlider).scrollable().seekTo(i, 0);

		}, 0);

	}
});
